<template>
  <div id="charts2"></div>
</template>
<script>
import echarts from "echarts";
export default {
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      const charts2 = echarts.init(document.getElementById("charts2"));
      const color = ["#fdad23", "#fecc56","#fedd8f","#ffeec7","#F4F4F4"]
      const option = {
        animation: false,
        color:color,
        // silent:true,
        grid:{
          left: '0',   // 与容器左侧的距离
          right: '0', // 与容器右侧的距离
          top: '0',   // 与容器顶部的距离
          bottom: '0', // 与容器底部的距离
        },
        legend: {
          orient: "vertical",
          right: '0',
          y: 'center',
          itemWidth: 10,
          itemHeight: 10,
          borderRadius: '50%',
          data: ["10000元以上", "8000-10000元", "5000-8000元", "3000-5000元", "3000元以下"]
        },
        series: [
          {
            // name: "访问来源",
            type: "pie",
            radius: ["55%", "80%"],
            center: ["30%", "50%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
                rich: {}
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "14",
                  fontWeight: "bold"
                },
                formatter: '{b}\n{d}%'
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: 335, name: "10000元以上", itemStyle: { emphasis:{ color: '#fdad23' } } },
              { value: 310, name: "8000-10000元", itemStyle: { emphasis:{ color: '#fecc56' } } },
              { value: 234, name: "5000-8000元", itemStyle: { emphasis:{ color: '#fedd8f' } } },
              { value: 135, name: "3000-5000元", itemStyle: { emphasis:{ color: '#ffeec7' } } },
              { value: 1548, name: "3000元以下", itemStyle: { emphasis:{ color: '#F4F4F4' } } }
            ]
          }
        ]
      }
      charts2.setOption(option)
    }
  }
};
</script>
<style lang="scss" scoped>
#charts2 {
  width: 100%;
  height: 350px;
}
</style>